import { useOktaAuth } from '@okta/okta-react'
import * as React from 'react'
import { connect } from 'react-redux'
import { IApplicationState } from 'redux/store/store'
import { VestigingEnum } from 'shared/models/Enum'
import { getRoles, hasRole } from 'shared/utils/roleHelpers'

interface IProps {
  vestiging: VestigingEnum
}

const About: React.FunctionComponent<IProps> = ({ vestiging }) => {
  const { authState } = useOktaAuth()
  const roles = getRoles(authState)

  return (
    <div>
      <h4>LBO Status</h4>
      <table>
        <tbody>
          <tr>
            <th>Ingestelde Vestiging</th>
            <td>
              {
                VestigingEnum[
                  vestiging === undefined ? VestigingEnum.Geen : vestiging
                ]
              }
            </td>
          </tr>
          <tr>
            <th>Gebruiker</th>
            <td>{authState.idToken.claims.name}</td>
          </tr>
          <tr>
            <th>Rollen</th>
            <td>{roles.join(' ')}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

const mapStateToProps = (store: IApplicationState) => {
  return {
    vestiging: store.globalState.vestiging,
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(About)
